import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { LibConfig, LibConfigService } from './jaakrecog-liveness-lib.module';
import { BestFrame } from './models/best-frame';
import { Builder } from 'builder-pattern';
import { MatDialog } from '@angular/material/dialog';
import { CaptureVideoComponent } from './capture-video/capture-video.component';
@Injectable({
  providedIn: 'root',
})
export class JaakrecogLivenessLibService {
  baseUrl = this.config.apiUrl;
  constructor(
    @Inject(LibConfigService) private config: LibConfig,
    private http: HttpClient,
    public dialogCtrl: MatDialog
  ) {}

  getData() {
    return this.http
      .get<any>(`${this.baseUrl}/api`)
      .pipe(map((res: any) => res.results[0]));
  }

  public async openVideoCapture(token: string): Promise<BestFrame> {
    const modal = this.dialogCtrl.open(CaptureVideoComponent, {
      height: '100vh',
      minHeight: '100vh',
      minWidth: '100%',
      width: '100%',
      panelClass: 'test-class',
      data: { token: token },
    });
    return await modal.afterClosed().toPromise();
  }

  public verifyBestFrame(
    video: Array<string>,
    token: string,
    eventId?: string
  ): Observable<BestFrame> {
    return this.http
      .post(
        `${this.baseUrl}/api/v1/liveness/verify/best-frame/`,
        {
          eventId,
          videos: video,
        },
        { headers: new HttpHeaders().set('auth', `Bearer ${token}`) }
      )
      .pipe(
        map((response: any) =>
          Builder(BestFrame)
            .id(response.eventId)
            .status(response.status)
            .evaluation(response.evaluation)
            .facesFound(response.faces_found)
            .message(response.message)
            .processTime(response.process_time)
            .bestFrame(response.best_frame)
            .build()
        )
      );
  }

  public async getPermissions(): Promise<MediaStream> {
    return navigator.mediaDevices
      .getUserMedia({ video: true })
      .then(async (stream) => {
        return stream;
      })
      .catch(async (e) => {
        return e;
      });
  }
}
